// https://jira.lais.net/browse/WEB-39857
export const res = {
  number: {
    is: 'Númer',
    en: 'Number',
    pl: 'Numer',
  },
  name: {
    is: 'Heiti',
    en: 'Name',
    pl: 'Nazwa',
  },
  balance: {
    is: 'Staða',
    en: 'Balance',
    pl: 'Saldo',
  },
  availableAmount: {
    is: 'Ráðstöfun',
    en: 'Available',
    pl: 'Dostępne',
  },
  selectWithdrawalAccount: {
    is: 'Veldu úttektarreikning',
    en: 'Select withdrawal account',
    pl: 'Wybierz konto do zapłaty',
  },
  selectAccounts: {
    is: 'Velja reikninga',
    // TODO: Translate
  },
  selectAccountsDescription: {
    is: 'TPP er að biðja um aðgang að reikningum',
    // TODO: Translate
  },
  selectColumn: {
    is: 'Velja',
    en: 'Select',
    pl: 'Wybierz',
  },
} as const;
